import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-portal-rt_tab_line",
  "use": "rt-portal-rt_tab_line-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-rt_tab_line\">\n<style type=\"text/css\">\n\t#rt-portal-rt_tab_line .st0{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<g id=\"rt-portal-rt_tab_line_图层_2\">\n</g>\n<g id=\"rt-portal-rt_tab_line_图层_1\">\n\t<path class=\"st0\" d=\"M126.4,111.7h768c8.8,0,16,5,16,11.2v73.7c0,6.2-7.2,11.2-16,11.2h-768c-8.8,0-16-5-16-11.2V123\n\t\tC110.4,116.7,117.6,111.7,126.4,111.7z\" />\n\t<path class=\"st0\" d=\"M126.4,464.1h768c8.8,0,16,5,16,11.2v73.6c0,6.2-7.2,11.2-16,11.2h-768c-8.8,0-16-5-16-11.2v-73.6\n\t\tC110.4,469.1,117.6,464.1,126.4,464.1z\" />\n\t<path class=\"st0\" d=\"M126.4,816.4h768c8.8,0,16,5,16,11.2v73.6c0,6.2-7.2,11.2-16,11.2h-768c-8.8,0-16-5-16-11.2v-73.6\n\t\tC110.4,821.4,117.6,816.4,126.4,816.4z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/rt_tab_line.svg
// module id = 1297
// module chunks = 116